function acceptRemoveBoardColumnDialogDirective () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/accept-remove-board-column-dialog/accept-remove-board-column-dialog.html?$$REVISION$$'
  }
}

export { acceptRemoveBoardColumnDialogDirective }
